import { render, staticRenderFns } from "./MaterialSearch.vue?vue&type=template&id=71778235&scoped=true&"
import script from "./MaterialSearch.vue?vue&type=script&lang=js&"
export * from "./MaterialSearch.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSearch.vue?vue&type=style&index=0&id=71778235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71778235",
  null
  
)

export default component.exports